<template>
	<div id="parent">
		<Home 		v-waypoint="{ active: true, callback: emitter, options: intersectionOptions}" 
					:profile-pic="acf.profile_pic"
					:signature="acf.logo_pic"
					:logo-mobile="acf.logo_mobile_pic"/>
		<About 		v-waypoint="{ active: true, callback: emitter, options: intersectionOptions}" 
					:bio="acf.bio"
					:left-image="acf.left_image"
					:right-image="acf.right_image"
					:custom-background="acf.media_background"/>
		<Headshot 	v-waypoint="{ active: true, callback: emitter, options: intersectionOptions}" 
					:resume-file="acf.resume"
					:resume-screenshot="acf.resume_screenshot"
					:headshot="acf.headshot"
					:headshot-screenshot="acf.headshot_screenshot"/>
		<Media 		:posts="posts"
					:media="media"
					:custombackground="acf.media_background"
					v-waypoint="{ active: true, callback: emitter, options: intersectionOptions}" />
		<News 		:news="posts"
					v-waypoint="{ active: true, callback: emitter, options: intersectionOptions}" />
		<Contact 	v-waypoint="{ active: true, callback: emitter, options: intersectionOptions}" />
		<div id="footer">
			<div class="footContainer">
				<div class="sponsorship" style="margin-right:0.5em; margin-left:auto; font-size:.3em">
					Made by
				</div>
				<a class="phreakLogo" target="_blank" rel="noopener" href="https://www.dmalaniouk.com"></a>
				<div class="sponsorship" style="margin-right: auto; font-size: .7em; line-height: 1rem">
					D.Malaniouk
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Home 	from '../views/Home';
import About 	from '../views/About';
import Headshot from '../views/Headshot';
import Media 	from '../views/Media';
import News 	from '../views/News';
import Contact 	from '../views/Contact';

import axios from 'axios';

export default{
	name:"MainLayout",
	components:{
		Home,
		About,
		Headshot,
		Media,
		News,
		Contact
	},
	data(){
		return{
			intersectionOptions:{
				root: null,
				rootMargin: '0px',
				threshold: [0.7]
			},
			acf: {
				bio:"",
				headshot:{},
				headshot_screenshot:{},
				left_image:{},
				logo_pic:{},
				logo_mobile_pic: {},
				media_background: {},
				profile_pic:{},
				resume:{},
				resume_screenshot:{},
				right_image:{}
			},
			posts: [{
				date: this.currDate,
				leftBuffer: 0,
				title: { rendered: "title" }
			}],
			media: {
				production: {
					tag: 14,
					links: [],
					post: {}
				},
				lifestyle: {
					tag: 16,
					links: [],
					post: {}
				},
				headshot: {
					tag: 8,
					links: [],
					post: {}
				},
				raw: []
			}
		}
	},
	created(){
		this.getPageContent();
		this.getPosts();
		this.getMedia();
	},
	methods : {
		emitter: function( {el, going, direction} ){
			if(going === this.$waypointMap.GOING_IN){ 
				this.$root.$emit('scrolled',el.id); 
			}
		},
		getPageContent: function(){
			let pageContentUrl = process.env.VUE_APP_WP_URL+"/wp-json/markers/v1/page"
			axios.get(pageContentUrl)
                .then(response => {
                	this.acf = response.data[0].acf;
                })
                .catch(error => {
                	let tmp = error;
                });
		},
		getPosts: function(){
			let postUrl = process.env.VUE_APP_WP_URL+"/wp-json/wp/v2/posts"
			axios.get(postUrl)
                .then(response => {
                	this.posts = response.data;
                })
                .catch(error => {
                	let tmp = error;
                });
		},
		getMedia: function(){
			let mediaUrl = process.env.VUE_APP_WP_URL+"/wp-json/gallery/v1/media";

			axios.get(mediaUrl)
				.then(response => {
					this.media.raw = response.data.posts;
				}).catch(error =>{
					let tmp = error;
				});
		}
	}
}
</script>

<style scoped lang="scss">
	@import "~@/assets/scss/_variables.scss";

	#parent{
		width: 100vw;
		height: 90vh;
		overscroll-behavior: none;
	}
	#footer{
		background: $nearWhite;

		.footContainer{
			width: 100vw;
			// margin: auto;
			display: flex;
	
			.phreakLogo{
				margin: auto;
				width: 3vh;
				height: 3vh;
				background-image: url('~@/assets/img/logo.png');
				background-size: contain;
				background-repeat: no-repeat;
				margin-left: 2px;
				margin-right: 2px;
			}

			.sponsorship{
				margin: .5em;
				font-size: 1em;
				font-family: 'Montserrat', sans-serif;
				text-align:center;
			}
		}

	}

	@media screen and (max-width: $tabletWidth){
		#parent{
			height: 85vh;
		}
	}

	@media screen and (max-width: $largeMobile){
		#parent{
			height: 100vh;
		}
	}

	@media screen and (max-width: $mediumMobile){

	}

	@media screen and (max-width: $smallMobile){

	}
</style>